export const amplifyConfig = {
	Auth: {
		Cognito: {
			userPoolId: process.env.NEXT_PUBLIC_AWS_USER_POOL_ID as string,
			userPoolClientId: process.env.NEXT_PUBLIC_AWS_APP_CLIENT_ID as string,
			loginWith: {
				oauth: {
					domain: process.env.NEXT_PUBLIC_AUTH_DOMAIN as string,
					scopes: ['openid', 'aws.cognito.signin.user.admin'],
					redirectSignIn: [process.env.NEXT_PUBLIC_COGNITO_REDIRECT as string],
					redirectSignOut: [process.env.NEXT_PUBLIC_LANDING_PAGE as string],
					responseType: 'code',
				},
			},
		},
	},
};
